import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar } from '@src/components/Avatar';
import { getNameInitials } from '@src/util/getNameInitials';
import './styles.scss';

const ROLES = {
  ADMIN: 'Admin',
  COLLABORATOR: 'Collaborator',
  RECRUITER: 'Recruiter',
};

export const MembersList = ({ teamMembers }) => (
  <div className="settings-team-members">
    {teamMembers.map(({ id, fullName, email, avatarColor, avatarUrl, role, lastSeen }) => (
      <div className="settings-team-members__row" key={id}>
        <div className="settings-team-members__col settings-team-members__col--name">
          <Avatar
            avatarColor={avatarColor}
            className="settings-team-members__avatar"
            initials={getNameInitials(fullName)}
            size="large"
            source={avatarUrl}
          />

          <span className="settings-team-members__name">{fullName}</span>
        </div>

        <div className="settings-team-members__col settings-team-members__col--email">{email}</div>

        <div className="settings-team-members__col settings-team-members__col--date">
          Last seen {moment(lastSeen).format('DD MMM YYYY')}
        </div>

        <div className="settings-team-members__col settings-team-members__col--role">{ROLES[role]}</div>
      </div>
    ))}
  </div>
);

MembersList.propTypes = {
  teamMembers: PropTypes.arrayOf(
    PropTypes.shape({
      avatarColor: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string,
      email: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      lastSeen: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
    }),
  ),
};
